var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _text, _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDrawerTemplate = function SvgDrawerTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "296.0mm",
    height: "190.0mm",
    viewBox: "-4.5 21.5 296.0 190.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 20.3,
    y1: 28.5,
    y2: 28.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3,
    x2: 20.3,
    y1: 27.5,
    y2: 28.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3,
    x2: 121.5,
    y1: 27.5,
    y2: 27.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    x2: 121.5,
    y1: 27.5,
    y2: 62.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 125.6,
    x2: 123.5,
    y1: 43.5,
    y2: 64.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 125.6,
    x2: 140.5,
    y1: 43.5,
    y2: 43.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 140.5,
    x2: 163.5,
    y1: 43.5,
    y2: 64.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 163.5,
    y1: 64.5,
    y2: 66.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 186.5,
    x2: 163.5,
    y1: 43.5,
    y2: 64.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 186.5,
    x2: 262.5,
    y1: 43.5,
    y2: 43.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 262.5,
    x2: 266.5,
    y1: 43.5,
    y2: 63.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    x2: 266.5,
    y1: 66.5,
    y2: 63.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    x2: 286.5,
    y1: 66.5,
    y2: 69.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 286.5,
    x2: 286.5,
    y1: 69.5,
    y2: 163.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    x2: 286.5,
    y1: 166.5,
    y2: 163.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    x2: 266.5,
    y1: 166.5,
    y2: 169.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 262.5,
    x2: 266.5,
    y1: 189.5,
    y2: 169.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 186.5,
    x2: 262.5,
    y1: 189.5,
    y2: 189.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 186.5,
    y1: 168.6,
    y2: 189.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 163.5,
    y1: 166.5,
    y2: 168.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 140.5,
    x2: 163.5,
    y1: 189.5,
    y2: 168.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 125.6,
    x2: 140.5,
    y1: 189.5,
    y2: 189.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 125.6,
    y1: 168.6,
    y2: 189.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    x2: 123.5,
    y1: 170.6,
    y2: 168.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    x2: 121.5,
    y1: 170.6,
    y2: 205.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3,
    x2: 121.5,
    y1: 205.5,
    y2: 205.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3,
    x2: 23.3,
    y1: 204.5,
    y2: 205.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 20.3,
    y1: 204.5,
    y2: 204.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y1: 168.5,
    y2: 204.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 18.3,
    y1: 168.5,
    y2: 168.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 18.3,
    y1: 166.5,
    y2: 168.6,
    stroke: "black",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 18.3,
    x2: 23.5,
    y1: 165.5,
    y2: 166.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 18.3,
    y1: 165.5,
    y2: 165.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y1: 67.5,
    y2: 165.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 18.3,
    y1: 67.5,
    y2: 67.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3,
    x2: 18.3,
    y1: 66.5,
    y2: 67.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 18.3,
    x2: 23.3,
    y1: 64.5,
    y2: 66.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 18.3,
    y1: 64.5,
    y2: 64.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y1: 28.5,
    y2: 64.5,
    stroke: "black",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 123.5,
    y1: 26.5,
    y2: 26.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 123.5,
    y1: 26.5,
    y2: 66.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 123.5,
    y1: 66.5,
    y2: 66.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 23.5,
    y1: 26.5,
    y2: 66.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 23.5,
    y1: 66.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 123.5,
    y1: 166.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 123.5,
    y1: 66.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 163.5,
    y1: 66.5,
    y2: 66.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 163.5,
    y1: 66.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 163.5,
    y1: 166.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 23.5,
    y1: 166.5,
    y2: 206.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 123.5,
    y1: 206.5,
    y2: 206.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 123.5,
    y1: 166.5,
    y2: 206.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 263.5,
    y1: 66.5,
    y2: 66.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    x2: 263.5,
    y1: 66.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 263.5,
    y1: 166.5,
    y2: 166.5,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "width"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    x2: 28.5,
    y1: 66.5,
    y2: 166.5,
    stroke: "black",
    strokeWidth: 0.5,
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    x2: 27.5,
    y1: 66.5,
    y2: 70.5,
    stroke: "black",
    strokeWidth: 0.5,
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    x2: 29.5,
    y1: 66.5,
    y2: 70.5,
    stroke: "black",
    strokeWidth: 0.5,
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    x2: 27.5,
    y1: 166.5,
    y2: 162.5,
    stroke: "black",
    strokeWidth: 0.5,
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    x2: 29.5,
    y1: 166.5,
    y2: 162.5,
    stroke: "black",
    strokeWidth: 0.5,
    style: {}
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 33.5,
    y: 118.5,
    fill: "#000",
    fontSize: 5.3333,
    textAnchor: "middle",
    transform: "rotate(-90,33.5,118.5)"
  }, "\n            Width\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 123.5,
    y1: 61.5,
    y2: 61.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 119.5,
    y1: 61.5,
    y2: 60.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 119.5,
    y1: 61.5,
    y2: 62.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 27.5,
    y1: 61.5,
    y2: 60.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    x2: 27.5,
    y1: 61.5,
    y2: 62.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 78.5,
    y: 59.5,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Depth\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    x2: 123.5,
    y1: 62.400002,
    y2: 64.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 163.5,
    y1: 61.5,
    y2: 61.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 159.5,
    y1: 61.5,
    y2: 60.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 159.5,
    y1: 61.5,
    y2: 62.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 127.5,
    y1: 61.5,
    y2: 60.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    x2: 127.5,
    y1: 61.5,
    y2: 62.5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 144.17252,
    y: 58.850876,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Height\n        "))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrawerTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drawer-template.fd585b9f.svg";
export { ForwardRef as ReactComponent };